var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.i18nt('designer.setting.switchWidth')}},[_c('el-input-number',{staticStyle:{"width":"100%"},model:{value:(_vm.optionModel.switchWidth),callback:function ($$v) {_vm.$set(_vm.optionModel, "switchWidth", $$v)},expression:"optionModel.switchWidth"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }